import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Roles from "@/components/Roles";
import Belief from "@/components/Belief";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main
      className="relative bg-[#0A0A0C] text-[#F5F5F5] min-h-screen overflow-x-hidden"
      data-testid="home-page"
    >
      <Nav />
      <Hero />
      <Roles />
      <Belief />
      <CTA />
      <Footer />
    </main>
  );
}
